import { toFiniteNumber } from 'utils/math/math.utils';

const getPositiveMinuteInterval = (value, name) => {
  const minutes = toFiniteNumber(value);

  if (minutes === null || minutes <= 0) {
    throw new RangeError(`${name} must be greater than zero.`);
  }

  return minutes;
};

/**
 * Builds the shared RTK Query refresh settings used by weather-map features.
 * RTK Query expects polling time in milliseconds and stale time in seconds,
 * while feature configs keep both values readable in minutes.
 *
 * @param {object} options - Refresh values expressed in minutes.
 * @param {number} options.refreshIntervalMinutes - Time between polling requests.
 * @param {number} [options.refetchIfOlderThanMinutes] - Cached-data age before refetching.
 * @returns {{pollingInterval: number, refetchOnMountOrArgChange: boolean|number}}
 */
export const createWeatherMapPollingQueryOptions = ({
  refreshIntervalMinutes,
  refetchIfOlderThanMinutes,
} = {}) => {
  const pollingMinutes = getPositiveMinuteInterval(
    refreshIntervalMinutes,
    'refreshIntervalMinutes',
  );
  const refetchOnMountOrArgChange =
    refetchIfOlderThanMinutes === undefined
      ? true
      : getPositiveMinuteInterval(refetchIfOlderThanMinutes, 'refetchIfOlderThanMinutes') * 60;

  return Object.freeze({
    pollingInterval: pollingMinutes * 60_000,
    refetchOnMountOrArgChange,
  });
};
